<template>
  <div class="w-full">
    <SparkSelect
      :options="levelOptions"
      v-model="selectedLevelKey"
      label="Own Parts"
      placeholder="Select ownership filter"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import SparkSelect from '@/components/SparkComponents/SparkSelect.vue';

export default {
  name: 'OwnFilter',

  components: { 
    SparkSelect 
  },

  props: {
    reset: { type: Number, required: true },
    component: { type: String, required: true },
    label: { type: String, required: true },
    parent: { type: String, required: true },
  },

  emits: ['selected'],

  data() {
    return {
      levels: {
        organization: 'All',
        user: 'Own',
      },
      selectedLevelKey: 'organization',
    };
  },

  computed: {
    levelOptions() {
      return Object.entries(this.levels).map(([key, label]) => ({
        value: key,
        label: label,
      }));
    },
  },

  watch: {
    selectedLevelKey(newKey) {
      this.$emit('selected', { query_type: newKey });
    },

    reset: {
      handler() {
        if (this.reset) {
          this.remove();
          this.selectedLevelKey = 'organization';
        }
      },
    },
  },

  mounted() {
    if (this.parent === 'library') {
      const filter = JSON.parse(sessionStorage.getItem('libraryFilter'));
      const owner = filter?.query_type;
      if (this.levels[owner]) {
        this.selectedLevelKey = owner;
      } else {
        this.selectedLevelKey = 'organization';
      }
    } else {
      this.selectedLevelKey = 'organization';
    }
    this.$emit('selected', { query_type: this.selectedLevelKey });
  },

  methods: {
    ...mapMutations(['disablePartLibraryFilter', 'resetFilter']),

    remove() {
      this.disablePartLibraryFilter({
        [this.label]: this.component,
      });
      this.resetFilter({ query_type: 'query_type' });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
